import { rtkQuerieSetup } from '../services/rtkQuerieSetup';

export const userAuthApi = rtkQuerieSetup.injectEndpoints({
    endpoints: builder => ({
        userLogin: builder.mutation({
            query: (userData) => ({
                url: `/user/login`,
                method: "POST",
                body: userData,
            }),
            invalidatesTags: ['GlobalData'],
        }),
        googleLogin: builder.mutation({
            query: ({ idToken, country, fcm_token }: { idToken: string, country?: string, fcm_token?: string }) => ({
                url: `/user/google-login`,
                method: "POST",
                headers: {
                    Authorization: `Bearer ${idToken}`,
                    "Content-Type": "application/json",
                },
                body: { idToken, country, fcm_token },
            }),
            invalidatesTags: ['GlobalData'],
        }),
        userRegister: builder.mutation({
            query: (userData) => ({
                url: `/user/register`,
                method: "POST",
                body: userData,
            }),
        }),
        /** Backend expects `{ user_id }` (email). */
        userForgotPassword: builder.mutation({
            query: ({ email }: { email: string }) => ({
                url: `/user/forgot-password`,
                method: "POST",
                body: { user_id: email },
            }),
        }),
        userResetPassword: builder.mutation({
            query: ({ token, payload }) => ({
                url: `/user/new-password`,
                method: "POST",
                body: payload,
                headers: { Authorization: `Bearer ${token}` },
            }),
        }),
        userVerifyOtp: builder.mutation({
            query: (userData) => ({
                url: `/user/verify`,
                method: "POST",
                body: userData,
            }),
            invalidatesTags: ['GlobalData'],
        }),
        userResendOtp: builder.mutation({
            query: (userData) => ({
                url: `/user/resend-code`,
                method: "POST",
                body: userData,
            }),
        }),
        userChangePassword: builder.mutation({
            query: (userData) => ({
                url: `/user/change-password`,
                method: "POST",
                body: userData,
            }),
        }),
        userUpdateProfile: builder.mutation({
            query: (userData) => ({
                url: `/user/update-profile`,
                method: "PUT",
                body: userData,
            }),
            invalidatesTags: ['UserProfile'],
        }),
    }),
});

export const {
    useUserLoginMutation,
    useGoogleLoginMutation,
    useUserRegisterMutation,
    useUserForgotPasswordMutation,
    useUserResetPasswordMutation,
    useUserVerifyOtpMutation,
    useUserResendOtpMutation,
    useUserChangePasswordMutation,
    useUserUpdateProfileMutation,
} = userAuthApi;